// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_poi.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_poi.proto.
 */
export const file_travplaces_v1_admin_poi: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * ManualPoi is a place shown in Admin for review, from any source. Manual rows
 * (source = "manual") are the only ones this service will edit or delete — an
 * imported row is rewritten by its next import, so a delete of one is a button
 * that appears to work and does not.
 *
 * @generated from message travplaces.v1.ManualPoi
 */
export type ManualPoi = Message<"travplaces.v1.ManualPoi"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string category_id = 3;
   */
  categoryId: string;

  /**
   * @generated from field: string category_key = 4;
   */
  categoryKey: string;

  /**
   * @generated from field: string category_label = 5;
   */
  categoryLabel: string;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: double lat = 7;
   */
  lat: number;

  /**
   * @generated from field: double lng = 8;
   */
  lng: number;

  /**
   * @generated from field: string address = 9;
   */
  address: string;

  /**
   * @generated from field: string description = 10;
   */
  description: string;

  /**
   * @generated from field: string website = 11;
   */
  website: string;

  /**
   * @generated from field: string phone = 12;
   */
  phone: string;

  /**
   * @generated from field: optional double rating = 13;
   */
  rating?: number | undefined;

  /**
   * @generated from field: optional int32 dwell_minutes_override = 14;
   */
  dwellMinutesOverride?: number | undefined;

  /**
   * @generated from field: bool is_active = 15;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp | undefined;

  /**
   * "osm" | "manual"
   *
   * @generated from field: string source = 17;
   */
  source: string;

  /**
   * A date the dataset says the place shut. Reserved for parity with the
   * legacy shape; the current pois table carries no closed_on column, so it is
   * always empty here.
   *
   * @generated from field: optional string closed_on = 18;
   */
  closedOn?: string | undefined;

  /**
   * 0–69, the planner's own notability measure from the place's own tags.
   *
   * @generated from field: int32 prominence = 19;
   */
  prominence: number;
};

/**
 * Describes the message travplaces.v1.ManualPoi.
 * Use `create(ManualPoiSchema)` to create a new message.
 */
export const ManualPoiSchema: GenMessage<ManualPoi> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 0);

/**
 * DuplicateCandidate is an existing place a proposed entry might be a second
 * copy of — near enough, and (when is_match) named alike enough, to be judged
 * the same place on the ground.
 *
 * @generated from message travplaces.v1.DuplicateCandidate
 */
export type DuplicateCandidate = Message<"travplaces.v1.DuplicateCandidate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category_key = 3;
   */
  categoryKey: string;

  /**
   * @generated from field: string category_label = 4;
   */
  categoryLabel: string;

  /**
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string address = 6;
   */
  address: string;

  /**
   * @generated from field: double lat = 7;
   */
  lat: number;

  /**
   * @generated from field: double lng = 8;
   */
  lng: number;

  /**
   * @generated from field: int32 distance_m = 9;
   */
  distanceM: number;

  /**
   * trigram overlap with the proposed name, 0..1
   *
   * @generated from field: double name_similarity = 10;
   */
  nameSimilarity: number;

  /**
   * @generated from field: bool is_match = 11;
   */
  isMatch: boolean;
};

/**
 * Describes the message travplaces.v1.DuplicateCandidate.
 * Use `create(DuplicateCandidateSchema)` to create a new message.
 */
export const DuplicateCandidateSchema: GenMessage<DuplicateCandidate> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 1);

/**
 * PoiCountRow is one category's place count, split by the source it came from.
 *
 * @generated from message travplaces.v1.PoiCountRow
 */
export type PoiCountRow = Message<"travplaces.v1.PoiCountRow"> & {
  /**
   * @generated from field: string category_key = 1;
   */
  categoryKey: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string group = 3;
   */
  group: string;

  /**
   * @generated from field: bool is_visitable = 4;
   */
  isVisitable: boolean;

  /**
   * @generated from field: int32 osm = 5;
   */
  osm: number;

  /**
   * @generated from field: int32 fsq = 6;
   */
  fsq: number;

  /**
   * @generated from field: int32 manual = 7;
   */
  manual: number;

  /**
   * @generated from field: int32 total = 8;
   */
  total: number;
};

/**
 * Describes the message travplaces.v1.PoiCountRow.
 * Use `create(PoiCountRowSchema)` to create a new message.
 */
export const PoiCountRowSchema: GenMessage<PoiCountRow> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 2);

/**
 * @generated from message travplaces.v1.ListAdminPoisRequest
 */
export type ListAdminPoisRequest = Message<"travplaces.v1.ListAdminPoisRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string q = 2;
   */
  q: string;

  /**
   * @generated from field: repeated string sources = 3;
   */
  sources: string[];

  /**
   * @generated from field: repeated string category_keys = 4;
   */
  categoryKeys: string[];

  /**
   * @generated from field: bool include_hidden = 5;
   */
  includeHidden: boolean;

  /**
   * @generated from field: bool notable_only = 6;
   */
  notableOnly: boolean;

  /**
   * @generated from field: int32 limit = 7;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 8;
   */
  offset: number;
};

/**
 * Describes the message travplaces.v1.ListAdminPoisRequest.
 * Use `create(ListAdminPoisRequestSchema)` to create a new message.
 */
export const ListAdminPoisRequestSchema: GenMessage<ListAdminPoisRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 3);

/**
 * @generated from message travplaces.v1.ListAdminPoisResponse
 */
export type ListAdminPoisResponse = Message<"travplaces.v1.ListAdminPoisResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.ManualPoi places = 1;
   */
  places: ManualPoi[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message travplaces.v1.ListAdminPoisResponse.
 * Use `create(ListAdminPoisResponseSchema)` to create a new message.
 */
export const ListAdminPoisResponseSchema: GenMessage<ListAdminPoisResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 4);

/**
 * @generated from message travplaces.v1.PoiCountsRequest
 */
export type PoiCountsRequest = Message<"travplaces.v1.PoiCountsRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string q = 2;
   */
  q: string;

  /**
   * @generated from field: repeated string sources = 3;
   */
  sources: string[];

  /**
   * @generated from field: bool include_hidden = 4;
   */
  includeHidden: boolean;
};

/**
 * Describes the message travplaces.v1.PoiCountsRequest.
 * Use `create(PoiCountsRequestSchema)` to create a new message.
 */
export const PoiCountsRequestSchema: GenMessage<PoiCountsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 5);

/**
 * @generated from message travplaces.v1.PoiCountsResponse
 */
export type PoiCountsResponse = Message<"travplaces.v1.PoiCountsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.PoiCountRow rows = 1;
   */
  rows: PoiCountRow[];

  /**
   * @generated from field: int32 hidden = 2;
   */
  hidden: number;
};

/**
 * Describes the message travplaces.v1.PoiCountsResponse.
 * Use `create(PoiCountsResponseSchema)` to create a new message.
 */
export const PoiCountsResponseSchema: GenMessage<PoiCountsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 6);

/**
 * @generated from message travplaces.v1.CreatePoiRequest
 */
export type CreatePoiRequest = Message<"travplaces.v1.CreatePoiRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * Exactly one of category_id / category_key identifies the category.
   *
   * @generated from field: string category_id = 2;
   */
  categoryId: string;

  /**
   * @generated from field: string category_key = 3;
   */
  categoryKey: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lng = 6;
   */
  lng: number;

  /**
   * @generated from field: string address = 7;
   */
  address: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * @generated from field: string website = 9;
   */
  website: string;

  /**
   * @generated from field: string phone = 10;
   */
  phone: string;

  /**
   * @generated from field: optional double rating = 11;
   */
  rating?: number | undefined;

  /**
   * @generated from field: optional int32 dwell_minutes_override = 12;
   */
  dwellMinutesOverride?: number | undefined;

  /**
   * Accepted for parity with the legacy input; create inserts directly.
   *
   * @generated from field: bool force = 13;
   */
  force: boolean;
};

/**
 * Describes the message travplaces.v1.CreatePoiRequest.
 * Use `create(CreatePoiRequestSchema)` to create a new message.
 */
export const CreatePoiRequestSchema: GenMessage<CreatePoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 7);

/**
 * @generated from message travplaces.v1.CreatePoiResponse
 */
export type CreatePoiResponse = Message<"travplaces.v1.CreatePoiResponse"> & {
  /**
   * @generated from field: travplaces.v1.ManualPoi poi = 1;
   */
  poi?: ManualPoi | undefined;
};

/**
 * Describes the message travplaces.v1.CreatePoiResponse.
 * Use `create(CreatePoiResponseSchema)` to create a new message.
 */
export const CreatePoiResponseSchema: GenMessage<CreatePoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 8);

/**
 * @generated from message travplaces.v1.UpdatePoiRequest
 */
export type UpdatePoiRequest = Message<"travplaces.v1.UpdatePoiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string category_id = 2;
   */
  categoryId?: string | undefined;

  /**
   * @generated from field: optional string category_key = 3;
   */
  categoryKey?: string | undefined;

  /**
   * @generated from field: optional string name = 4;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional double lat = 5;
   */
  lat?: number | undefined;

  /**
   * @generated from field: optional double lng = 6;
   */
  lng?: number | undefined;

  /**
   * @generated from field: optional string address = 7;
   */
  address?: string | undefined;

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string | undefined;

  /**
   * @generated from field: optional string website = 9;
   */
  website?: string | undefined;

  /**
   * @generated from field: optional string phone = 10;
   */
  phone?: string | undefined;

  /**
   * @generated from field: optional double rating = 11;
   */
  rating?: number | undefined;

  /**
   * @generated from field: optional int32 dwell_minutes_override = 12;
   */
  dwellMinutesOverride?: number | undefined;

  /**
   * @generated from field: optional bool is_active = 13;
   */
  isActive?: boolean | undefined;

  /**
   * @generated from field: bool force = 14;
   */
  force: boolean;
};

/**
 * Describes the message travplaces.v1.UpdatePoiRequest.
 * Use `create(UpdatePoiRequestSchema)` to create a new message.
 */
export const UpdatePoiRequestSchema: GenMessage<UpdatePoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 9);

/**
 * @generated from message travplaces.v1.UpdatePoiResponse
 */
export type UpdatePoiResponse = Message<"travplaces.v1.UpdatePoiResponse"> & {
  /**
   * @generated from field: travplaces.v1.ManualPoi poi = 1;
   */
  poi?: ManualPoi | undefined;
};

/**
 * Describes the message travplaces.v1.UpdatePoiResponse.
 * Use `create(UpdatePoiResponseSchema)` to create a new message.
 */
export const UpdatePoiResponseSchema: GenMessage<UpdatePoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 10);

/**
 * @generated from message travplaces.v1.AdminDeletePoiRequest
 */
export type AdminDeletePoiRequest = Message<"travplaces.v1.AdminDeletePoiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.AdminDeletePoiRequest.
 * Use `create(AdminDeletePoiRequestSchema)` to create a new message.
 */
export const AdminDeletePoiRequestSchema: GenMessage<AdminDeletePoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 11);

/**
 * @generated from message travplaces.v1.AdminDeletePoiResponse
 */
export type AdminDeletePoiResponse = Message<"travplaces.v1.AdminDeletePoiResponse"> & {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted: boolean;
};

/**
 * Describes the message travplaces.v1.AdminDeletePoiResponse.
 * Use `create(AdminDeletePoiResponseSchema)` to create a new message.
 */
export const AdminDeletePoiResponseSchema: GenMessage<AdminDeletePoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 12);

/**
 * @generated from message travplaces.v1.PoiDuplicatesRequest
 */
export type PoiDuplicatesRequest = Message<"travplaces.v1.PoiDuplicatesRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: double lat = 3;
   */
  lat: number;

  /**
   * @generated from field: double lng = 4;
   */
  lng: number;

  /**
   * @generated from field: optional string exclude_id = 5;
   */
  excludeId?: string | undefined;
};

/**
 * Describes the message travplaces.v1.PoiDuplicatesRequest.
 * Use `create(PoiDuplicatesRequestSchema)` to create a new message.
 */
export const PoiDuplicatesRequestSchema: GenMessage<PoiDuplicatesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 13);

/**
 * @generated from message travplaces.v1.PoiDuplicatesResponse
 */
export type PoiDuplicatesResponse = Message<"travplaces.v1.PoiDuplicatesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.DuplicateCandidate candidates = 1;
   */
  candidates: DuplicateCandidate[];

  /**
   * @generated from field: int32 radius_m = 2;
   */
  radiusM: number;

  /**
   * @generated from field: double similarity = 3;
   */
  similarity: number;
};

/**
 * Describes the message travplaces.v1.PoiDuplicatesResponse.
 * Use `create(PoiDuplicatesResponseSchema)` to create a new message.
 */
export const PoiDuplicatesResponseSchema: GenMessage<PoiDuplicatesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_poi, 14);

/**
 * AdminPoiService manages places held in the pois table by hand: listing them
 * for review, counting them by source, adding manual entries, and the
 * duplicate check that stops one being entered twice.
 *
 * @generated from service travplaces.v1.AdminPoiService
 */
export const AdminPoiService: GenService<{
  /**
   * ListAdminPois returns a page of a city's places, from any source, filtered.
   *
   * @generated from rpc travplaces.v1.AdminPoiService.ListAdminPois
   */
  listAdminPois: {
    methodKind: "unary";
    input: typeof ListAdminPoisRequestSchema;
    output: typeof ListAdminPoisResponseSchema;
  },
  /**
   * PoiCounts returns per-category counts by source, for reviewing provenance.
   *
   * @generated from rpc travplaces.v1.AdminPoiService.PoiCounts
   */
  poiCounts: {
    methodKind: "unary";
    input: typeof PoiCountsRequestSchema;
    output: typeof PoiCountsResponseSchema;
  },
  /**
   * CreatePoi adds a hand-entered place (source = manual).
   *
   * @generated from rpc travplaces.v1.AdminPoiService.CreatePoi
   */
  createPoi: {
    methodKind: "unary";
    input: typeof CreatePoiRequestSchema;
    output: typeof CreatePoiResponseSchema;
  },
  /**
   * UpdatePoi edits a manual place.
   *
   * @generated from rpc travplaces.v1.AdminPoiService.UpdatePoi
   */
  updatePoi: {
    methodKind: "unary";
    input: typeof UpdatePoiRequestSchema;
    output: typeof UpdatePoiResponseSchema;
  },
  /**
   * DeletePoi removes a manual place.
   *
   * @generated from rpc travplaces.v1.AdminPoiService.DeletePoi
   */
  deletePoi: {
    methodKind: "unary";
    input: typeof AdminDeletePoiRequestSchema;
    output: typeof AdminDeletePoiResponseSchema;
  },
  /**
   * PoiDuplicates reports what a proposed place might duplicate, writing nothing.
   *
   * @generated from rpc travplaces.v1.AdminPoiService.PoiDuplicates
   */
  poiDuplicates: {
    methodKind: "unary";
    input: typeof PoiDuplicatesRequestSchema;
    output: typeof PoiDuplicatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_poi, 0);

